import Accordion from './accordion';
import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      sliderContainer: this.el.querySelector('.swiper-container'),
      sliderWrapper: this.el.querySelector('.swiper-wrapper'),
      sliderPagination: this.el.querySelector('.partner-slider-v2__item'),
      slides: [...this.el.querySelectorAll('.swiper-slide')],
      accordion: this.el.querySelector('.partner-slider-v2__container--mobile'),
      marker: this.el.querySelector('.marker'),
      imageWrapper: this.el.querySelector('.image-v2__wrapper')
    };

    this.originalWindowWidth = window.innerWidth;

    this.initSlider();

    if (this.dom.accordion) {
      this.initAccordion();
    }
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    if (this.getIsMobile()) return;

    if (this.originalWindowWidth === window.innerWidth) {
      return;
    }

    this.setMarker(this.getBulletActive());
  }

  getIsMobile() {
    return window.matchMedia('(max-width: 1024px)').matches; // this is the breakpoint set for mobile in _variables.scss
  }

  getH3FromSlide(index) {
    return this.dom.slides[index].querySelector('h3').innerHTML.trim();
  }

  getImageFromSlide(index) {
    return this.dom.slides[index].querySelector('article').dataset.image;
  }

  getAltFromSlide(index) {
    return this.dom.slides[index].querySelector('article').dataset.alt;
  }

  initSlider() {
    const slideContents = this.el.querySelectorAll('.case-studies-grid-v2__item--text');
    let maxHeight = 0;

    Array.from(slideContents).forEach(item => {
      const itemHeight = item.offsetHeight;
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });

    this.dom.sliderWrapper.style.height = `${maxHeight}px`;

    this.swiper = new Swiper(this.dom.sliderContainer, {
      direction: 'vertical',
      slidesPerView: 1,
      autoHeight: true,
      pagination: {
        el: this.dom.sliderPagination,
        clickable: true,
        renderBullet: (index, className) => {
          return `<div data-image="${this.getImageFromSlide(index)}" data-alt="${this.getAltFromSlide(index)}" class="${className}"><span class="sc-only">Go to </span>${this.getH3FromSlide(
            index
          )}</div>`;
        }
      }
    });

    this.swiper.on('slideChange', () => {
      const bulletActive = this.getBulletActive();
      this.setMarker(bulletActive);
      this.removeAriaLabel();
      this.updateImage(bulletActive);
    });

    if (!this.getIsMobile()) {
      this.updateImage(this.getBulletActive());
    }
    this.removeAriaLabel();

    this.setMarker(this.getBulletActive());
  }

  updateImage(bulletActive) {
    const imageSrc = bulletActive.dataset.image;
    const imageAlt = bulletActive.dataset.alt;

    const sourceEl = this.dom.imageWrapper.querySelector('source');
    const imgEl = this.dom.imageWrapper.querySelector('img');

    sourceEl.srcset = imageSrc;
    imgEl.src = imageSrc;
    imgEl.alt = imageAlt;
  }

  getBulletActive() {
    return this.el.querySelector('.swiper-pagination-bullet-active');
  }

  removeAriaLabel() {
    this.el
      .querySelectorAll('.swiper-pagination-bullet')
      .forEach((element, index) => {
        element.removeAttribute('aria-label');
      });
  }

  setMarker(currentTab) {
    if (currentTab) {
      const bodyRect = this.el
        .querySelector('.swiper-pagination-bullets')
        .getBoundingClientRect();

      const clientRect = currentTab.getBoundingClientRect();
      this.dom.marker.style.height = `${clientRect.height}px`;
      this.dom.marker.style.marginTop = `${clientRect.y - bodyRect.y}px`;
    }
  }

  accordionMobileItemTemplate(element, opened) {
    return `
    <div class="accordion-item ${opened}">
      <button class="accordion-item__button">
          ${this.getH3(element)}
      </button>
      <div class="accordion-item__details">
          ${this.getParagraph(element)}
      </div>
    </div>`;
  }

  getH3(element) {
    return element.querySelector('h3').innerHTML;
  }

  getParagraph(element) {
    return element.querySelector('p').innerHTML;
  }
  initAccordion() {
    this.dom.slides.forEach((slide, index) => {
      this.dom.accordion.querySelector(
        'div'
      ).innerHTML += this.accordionMobileItemTemplate(
        slide,
        index === 0 ? 'opened' : ''
      );
    });
    new Accordion(this.dom.accordion);
  }
}

export default Module;
